import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Problem, Submission, SubmissionList, ViewOption } from "types/assignment/assignment"

export const VIEW_OPTIONS: ViewOption[] = [
  {
    label: "Description",
    value: "description",
  },
  {
    label: "My Submissions",
    value: "submissions",
  },
]

interface AssignmentState {
  testSlug: string | null
  problemId: string | null
  sessionId: string | null
  answer: string
  problem: Problem | null
  submissions: SubmissionList
  selectedSubmission: Submission | null
  panelView: ViewOption
}

const initialState: AssignmentState = {
  testSlug: null,
  problemId: null,
  sessionId: null,
  problem: null,
  answer: "",
  panelView: VIEW_OPTIONS[0]!,
  submissions: {
    data: [],
    pageNumber: 1,
    pageSize: 10,
  },
  selectedSubmission: null,
}

const assignmentSlice = createSlice({
  name: "assignment",
  initialState,
  reducers: {
    setTestSlug: (state, action: PayloadAction<string>) => {
      state.testSlug = action.payload
    },
    setProblemId: (state, action: PayloadAction<string>) => {
      state.problemId = action.payload
    },
    setSessionId: (state, action: PayloadAction<string>) => {
      state.sessionId = action.payload
    },
    setPanelView: (state, action: PayloadAction<ViewOption>) => {
      state.panelView = action.payload
    },
    setProblem: (state, action: PayloadAction<Problem>) => {
      state.problem = action.payload
    },
    setAnswer: (state, action: PayloadAction<string>) => {
      state.answer = action.payload
    },
    setSubmissionsPageNumber: (state, action: PayloadAction<number>) => {
      state.submissions.pageNumber = action.payload
    },
    setSubmissionsData: (state, action: PayloadAction<Submission[]>) => {
      state.submissions.data = action.payload
    },
    resetSubmissionPageNumber: (state) => {
      state.submissions.pageNumber = 1
    },
    setSelectedSubmission: (state, action: PayloadAction<Submission | null>) => {
      state.selectedSubmission = action.payload
    },
    resetState: () => initialState,
  },
})

export const {
  setTestSlug,
  setSessionId,
  setProblemId,
  setProblem,
  setAnswer,
  setPanelView,
  setSubmissionsPageNumber,
  setSubmissionsData,
  setSelectedSubmission,
  resetSubmissionPageNumber,
} = assignmentSlice.actions
export default assignmentSlice.reducer
